export const CONTROL_TYPE_OPTIONS = [
  { label: 'Multi-Terminal Shared', value: 'GLOBAL' },
  { label: 'Multi-Terminal', value: 'ALL' },
  { label: 'Single Terminal', value: 'SINGLE' },
];
export const AUTH_TYPE_OPTIONS = [
  { label: 'Product Specific', value: 'SPECIFIC' },
  { label: 'Unlimited', value: 'UNLIMITED' },
  { label: 'Limited', value: 'LIMITED' },
  { label: 'Monthly', value: 'MONTHLY' },
  { label: 'Semi-Monthly', value: 'SEMIMONTHLY' },
  { label: 'Weekly', value: 'WEEKLY' },
  { label: 'Daily', value: 'DAILY' },
  { label: '1 Vol Monthly', value: 'ONEVOLMONTH' },
  { label: '1 Vol Weekly', value: 'ONEVOLWEEKLY' },
  { label: '1 Vol Daily', value: 'ONEVOLDAILY' },
  { label: 'One Time', value: 'ONETIME' },
  { label: 'One Load', value: 'ONELOAD' },
];
export const STATUS_OPTIONS = [
  { label: 'All Statuses', value: 'ALLSTATUSES' },
  { label: 'All On', value: 'ACTIVE' },
  { label: 'All Off', value: 'INACTIVE' },
];
export const DEFAULT_STATUS = STATUS_OPTIONS[1]; // Default to "All On"
